import axios from 'axios';
import {
  all, call, put, takeEvery,
} from 'redux-saga/effects';

import { constants as fetcherConstants } from './creator';

const DEFAULT_CONFIG = {
};

const AXIOS_INSTANCE = axios.create(DEFAULT_CONFIG);

AXIOS_INSTANCE.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);

AXIOS_INSTANCE.interceptors.response.use(
  ({ data, status, headers }) => ({ data, status, headers }),
  (error) => Promise.reject(error),
);

function* handleAPICall({ payload }) {
  const {
 label = {}, fetcherParams, headers, onSuccess, onFailure,
} = payload;
  try {
    yield put({ type: label.REQUEST });

    const response = yield call(AXIOS_INSTANCE.request, {
      ...fetcherParams,
      headers: {
        ...headers,
      },
    });
    if (onSuccess) yield call(onSuccess, response);
    yield put({
      type: label.SUCCESS,
      response: response.data,
      reqPayload: payload,
    });
  } catch (error) {
    if (onFailure) yield call(onFailure, error);
    yield put({ type: label.FAILURE, error, reqPayload: payload });
  } finally {
    yield put({ type: label.FULFIL, reqPayload: payload });
  }
}

export default function* assessmentSagas() {
  yield all([takeEvery(fetcherConstants.API, handleAPICall)]);
}
